import React from 'react';
import { useLanguage } from '@/components/ui/LanguageContext';
import { motion } from 'framer-motion';
import { Building } from 'lucide-react';

export default function Commerce() {
  const { language } = useLanguage();

  return (
    <div className="min-h-screen bg-black text-white pb-20">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <div className="flex items-center gap-3 mb-8">
            <div className="p-3 rounded-xl bg-indigo-500/20">
              <Building className="w-6 h-6 text-indigo-400" />
            </div>
            <h1 className="text-3xl font-bold">
              {language === 'ja' ? '特定商取引法に基づく表記' : 'Commercial Disclosure'}
            </h1>
          </div>

          <div className="space-y-6">
            <div className="p-4 bg-zinc-900/50 rounded-xl border border-zinc-800">
              <h3 className="text-sm text-zinc-500 mb-1">
                {language === 'ja' ? '販売事業者' : 'Seller'}
              </h3>
              <p className="font-medium">LearnHub Inc.</p>
            </div>

            <div className="p-4 bg-zinc-900/50 rounded-xl border border-zinc-800">
              <h3 className="text-sm text-zinc-500 mb-1">
                {language === 'ja' ? '運営責任者' : 'Representative'}
              </h3>
              <p className="font-medium">山田 太郎</p>
            </div>

            <div className="p-4 bg-zinc-900/50 rounded-xl border border-zinc-800">
              <h3 className="text-sm text-zinc-500 mb-1">
                {language === 'ja' ? '所在地' : 'Address'}
              </h3>
              <p className="font-medium">
                {language === 'ja' 
                  ? '〒100-0001 東京都千代田区千代田1-1-1'
                  : '1-1-1 Chiyoda, Chiyoda-ku, Tokyo 100-0001, Japan'}
              </p>
            </div>

            <div className="p-4 bg-zinc-900/50 rounded-xl border border-zinc-800">
              <h3 className="text-sm text-zinc-500 mb-1">
                {language === 'ja' ? 'お問い合わせ' : 'Contact'}
              </h3>
              <p className="font-medium">support@learnhub.example.com</p>
            </div>

            <div className="p-4 bg-zinc-900/50 rounded-xl border border-zinc-800">
              <h3 className="text-sm text-zinc-500 mb-1">
                {language === 'ja' ? '販売価格' : 'Pricing'}
              </h3>
              <ul className="space-y-1 font-medium">
                <li>{language === 'ja' ? '月額プラン: ¥1,980（税込）' : 'Monthly Plan: ¥1,980 (incl. tax)'}</li>
                <li>{language === 'ja' ? '年額プラン: ¥19,800（税込）' : 'Yearly Plan: ¥19,800 (incl. tax)'}</li>
              </ul>
            </div>

            <div className="p-4 bg-zinc-900/50 rounded-xl border border-zinc-800">
              <h3 className="text-sm text-zinc-500 mb-1">
                {language === 'ja' ? '支払方法' : 'Payment Method'}
              </h3>
              <p className="font-medium">
                {language === 'ja' ? 'クレジットカード（Visa, Mastercard, American Express）' : 'Credit Card (Visa, Mastercard, American Express)'}
              </p>
            </div>

            <div className="p-4 bg-zinc-900/50 rounded-xl border border-zinc-800">
              <h3 className="text-sm text-zinc-500 mb-1">
                {language === 'ja' ? '商品の引渡時期' : 'Service Delivery'}
              </h3>
              <p className="font-medium">
                {language === 'ja' ? '決済完了後、即時利用可能' : 'Available immediately after payment'}
              </p>
            </div>

            <div className="p-4 bg-zinc-900/50 rounded-xl border border-zinc-800">
              <h3 className="text-sm text-zinc-500 mb-1">
                {language === 'ja' ? '返品・キャンセルについて' : 'Returns & Cancellation'}
              </h3>
              <p className="text-zinc-300 leading-relaxed">
                {language === 'ja'
                  ? 'デジタルコンテンツの性質上、購入後の返金は原則としてお受けしておりません。サブスクリプションはいつでもキャンセル可能で、キャンセル後も現在の請求期間の終了まで利用可能です。'
                  : 'Due to the nature of digital content, refunds are generally not available after purchase. Subscriptions can be cancelled at any time, and access continues until the end of the current billing period.'}
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
}